// extracted by mini-css-extract-plugin
module.exports = {"sidebarLinkWidget":"SidebarLinkMenu_sidebarLinkWidget__1H0VZ"};